
import Button from '../../../components/base/Button';

export default function AboutIntro() {
  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Content */}
          <div>
            <h2 className="text-4xl md:text-5xl font-bold text-brand-blue mb-6">
              Leading Fire Safety 
              <span className="text-brand-red"> Experts</span>
            </h2>
            <div className="w-24 h-1 bg-brand-red mb-6"></div>
            
            <p className="text-lg text-gray-600 mb-6 leading-relaxed">
              With over 15 years of experience in the fire safety industry, FlameGuardQA has 
              established itself as the premier provider of comprehensive fire protection solutions 
              across the region.
            </p>
            
            <p className="text-lg text-gray-600 mb-8 leading-relaxed">
              We specialize in designing, installing, and maintaining state-of-the-art fire safety 
              systems that protect lives and property. Our team of certified professionals ensures 
              every project meets the highest safety standards.
            </p>

            {/* Key Points */}
            <div className="space-y-4 mb-8">
              <div className="flex items-center space-x-3">
                <div className="w-6 h-6 bg-brand-red rounded-full flex items-center justify-center">
                  <i className="ri-check-line text-white text-sm"></i>
                </div>
                <span className="text-gray-700 font-medium">Certified by international safety standards</span>
              </div>
              <div className="flex items-center space-x-3">
                <div className="w-6 h-6 bg-brand-red rounded-full flex items-center justify-center">
                  <i className="ri-check-line text-white text-sm"></i>
                </div>
                <span className="text-gray-700 font-medium">24/7 emergency response and support</span>
              </div>
              <div className="flex items-center space-x-3">
                <div className="w-6 h-6 bg-brand-red rounded-full flex items-center justify-center">
                  <i className="ri-check-line text-white text-sm"></i>
                </div>
                <span className="text-gray-700 font-medium">Comprehensive maintenance and inspection services</span>
              </div>
              <div className="flex items-center space-x-3">
                <div className="w-6 h-6 bg-brand-red rounded-full flex items-center justify-center">
                  <i className="ri-check-line text-white text-sm"></i>
                </div>
                <span className="text-gray-700 font-medium">Custom solutions for every industry</span>
              </div>
            </div>

            <Button size="lg" className="transform hover:scale-105">
              <i className="ri-information-line mr-2"></i>
              Learn More About Us
            </Button>
          </div>

          {/* Image */}
          <div className="relative h-64 md:h-80 rounded-lg overflow-hidden">
            <img 
              src="https://readdy.ai/api/search-image?query=Professional%20fire%20safety%20engineers%20installing%20modern%20fire%20suppression%20systems%20in%20commercial%20building%2C%20clean%20industrial%20setting%20with%20safety%20equipment%20and%20technical%20precision%2C%20bright%20professional%20lighting&width=600&height=400&seq=about-intro-image&orientation=landscape"
              alt="Fire Safety Installation"
              className="w-full h-full object-cover"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
